// Module
var code = `<base-button btn-context="{{btnContext}}" btn-type="{{btnType}}" btn-size="{{btnSize}}" type="{{type}}"> <i class="fa fa-times" ng-if="btnIconOnly"></i> <span ng-if="!btnIconOnly" translate>Generic.Cancel</span> </base-button> `;
// Exports
module.exports = code;